import { useSelector } from "react-redux";
import { selectRegistration } from "../../redux/slices/userSlice";
import { time } from "framer-motion";
import { generateFcmToken } from "../../../fcmService";
import { deleteFcmToken, saveFcmToken } from "../../api/FcmApi";
import { saveLoginRecord } from "../../api/auth";
export const getUOMs  = [
    { value: "BAG", label: "BAGS" },
    { value: "BAL", label: "BALE" },
    { value: "BDL", label: "BUNDLES" },
    { value: "BKL", label: "BUCKLES" },
    { value: "BOU", label: "BILLION OF UNITS" },
    { value: "BOX", label: "BOX" },
    { value: "BTL", label: "BOTTLES" },
    { value: "BUN", label: "BUNCHES" },
    { value: "CAN", label: "CANS" },
    { value: "CBM", label: "CUBIC METERS" },
    { value: "CCM", label: "CUBIC CENTIMETERS" },
    { value: "CMS", label: "CENTI METERS" },
    { value: "CTN", label: "CARTONS" },
    { value: "DOZ", label: "DOZENS" },
    { value: "DRM", label: "DRUMS" },
    { value: "GGK", label: "GREAT GROSS" },
    { value: "GMS", label: "GRAMMES" },
    { value: "GRS", label: "GROSS" },
    { value: "GYD", label: "GROSS YARDS" },
    { value: "KGS", label: "KILOGRAMS" },
    { value: "KLR", label: "KILOLITRE" },
    { value: "KME", label: "KILOMETRE" },
    { value: "LTR", label: "LITRES" },
    { value: "MTR", label: "METERS" },
    { value: "MLT", label: "MILILITRE" },
    { value: "MTS", label: "METRIC TON" },
    { value: "NOS", label: "NUMBERS" },
    { value: "OTH", label: "OTHERS" },
    { value: "PAC", label: "PACKS" },
    { value: "PCS", label: "PIECES" },
    { value: "PRS", label: "PAIRS" },
    { value: "QTL", label: "QUINTAL" },
    { value: "ROL", label: "ROLLS" },
    { value: "SET", label: "SETS" },
    { value: "SQF", label: "SQUARE FEET" },
    { value: "SQM", label: "SQUARE METERS" },
    { value: "SQY", label: "SQUARE YARDS" },
    { value: "TBS", label: "TABLETS" },
    { value: "TGM", label: "TEN GROSS" },
    { value: "THD", label: "THOUSANDS" },
    { value: "TON", label: "TONNES" },
    { value: "TUB", label: "TUBES" },
    { value: "UGS", label: "US GALLONS" },
    { value: "UNT", label: "UNITS" },
    { value: "YDS", label: "YARDS" },
    { value: "RUI", label: "RUN INCH" },
  ];

 export const DEFAULT_PRODUCT_FILTERS = {
  productType: "",
  name: "",
  sku: "",
  barcode: "",
  category: "",
  subCategory: "",
  brand: "",
  status: "active",
  psin: "",
  globalCatalogue: "all",
};

export const DEFAULT_DELIVERYLIST_FILTERS={
    searchTransactionNo: "",
    searchCustomerDetail: "",
    dateRange: [null, null],
    searchStore: "",
    searchEmployeeName: "",
    externalTransactionNo: "",
    searchTransactionFrom: "",
    searchTransactionTo: "",
    sortBy:"asc"
  };
export const isEqualFilters = (a = {}, b = {}) =>
  JSON.stringify(a) === JSON.stringify(b);

export const formatDataAccessDays = (type, moduleAcl) => {
  if (!moduleAcl || typeof moduleAcl.dataAccessDays !== "number") return null;

  const today = new Date();
  const fromDateCalc = new Date();
  fromDateCalc.setDate(today.getDate() - moduleAcl.dataAccessDays);

  // Format date to yyyy-mm-dd
  const formatDate = (date) => date.toISOString().split('T')[0];

  if (type === "fromDate") return formatDate(fromDateCalc);
  if (type === "toDate") return formatDate(today);

  return null; // fallback
};

  export const formatLocalDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};


   export const petTypes = [
      { label: "Dogs", value: "Dogs" },
      { label: "Cats", value: "Cats" },
      { label: "Fish", value: "Fish" },
      { label: "Birds", value: "Birds" },
      { label: "Others", value: "Others" },
    ];

    export  const petBreeds = [
    // 🐶 Dogs
    { type: "Dogs", label: "Labrador Retriever", value: "Labrador Retriever" },
    { type: "Dogs", label: "German Shepherd", value: "German Shepherd" },
    { type: "Dogs", label: "Golden Retriever", value: "Golden Retriever" },
    { type: "Dogs", label: "Dachshund", value: "Dachshund" },
    { type: "Dogs", label: "Beagle", value: "Beagle" },
    { type: "Dogs", label: "Boxer", value: "Boxer" },
    { type: "Dogs", label: "Tibetan Mastiff", value: "Tibetan Mastiff" },
    { type: "Dogs", label: "English Cocker Spaniel", value: "English Cocker Spaniel" },
    { type: "Dogs", label: "Pug", value: "Pug" },
    { type: "Dogs", label: "Rottweiler", value: "Rottweiler" },
    { type: "Dogs", label: "Doberman", value: "Doberman" },
    { type: "Dogs", label: "Great Dane", value: "Great Dane" },
    { type: "Dogs", label: "Pomeranian", value: "Pomeranian" },
    { type: "Dogs", label: "Dalmatian", value: "Dalmatian" },
    { type: "Dogs", label: "Indian Spitz", value: "Indian Spitz" },
    { type: "Dogs", label: "Pekingese", value: "Pekingese" },
    { type: "Dogs", label: "Akita", value: "Akita" },
    { type: "Dogs", label: "St. Bernard", value: "St. Bernard" },
    { type: "Dogs", label: "Bichon Frise", value: "Bichon Frise" },
    { type: "Dogs", label: "French Bulldog", value: "French Bulldog" },
    { type: "Dogs", label: "English Bulldog", value: "English Bulldog" },
    { type: "Dogs", label: "Yorkshire Terrier", value: "Yorkshire Terrier" },
    { type: "Dogs", label: "Cane Corso", value: "Cane Corso" },
    { type: "Dogs", label: "Chow Chow", value: "Chow Chow" },
    { type: "Dogs", label: "Maltese", value: "Maltese" },
    { type: "Dogs", label: "Poodle", value: "Poodle" },
    { type: "Dogs", label: "Siberian Hasky", value: "Siberian Hasky" },
    { type: "Dogs", label: "Shihtzu", value: "Shihtzu" },
    { type: "Dogs", label: "Pitbull", value: "Pitbull" },
    { type: "Dogs", label: "Indian Dog", value: "Indian Dog" },

    // 🐱 Cats
    { type: "Cats", label: "Bombay Cat", value: "Bombay Cat" },
    { type: "Cats", label: "Himalayan Cat", value: "Himalayan Cat" },
    { type: "Cats", label: "Siamese Cat", value: "Siamese Cat" },
    { type: "Cats", label: "Persian Cat", value: "Persian Cat" },
    { type: "Cats", label: "Maine Coon", value: "Maine Coon" },
    { type: "Cats", label: "The American Bobtail", value: "The American Bobtail" },
    { type: "Cats", label: "Spotted Cat", value: "Spotted Cat" },

    // 🐦 Birds
    { type: "Birds", label: "Dove", value: "Dove" },
    { type: "Birds", label: "Zebra Finches", value: "Zebra Finches" },
    { type: "Birds", label: "Hyacinth Macaw", value: "Hyacinth Macaw" },
    { type: "Birds", label: "Pineapple Conures", value: "Pineapple Conures" },
    { type: "Birds", label: "Cockatiels", value: "Cockatiels" },
    { type: "Birds", label: "Parrotlet", value: "Parrotlet" },
    { type: "Birds", label: "Budgies", value: "Budgies" },
    { type: "Birds", label: "Hahn’s Macaw", value: "Hahn’s Macaw" },
    { type: "Birds", label: "Love Birds", value: "Love Birds" },

    // 🐟 Fish
    { type: "Fish", label: "Betta Fish", value: "Betta Fish" },
    { type: "Fish", label: "Guppy Fish", value: "Guppy Fish" },
    { type: "Fish", label: "Flowerhorn Fish", value: "Flowerhorn Fish" },
    { type: "Fish", label: "Gold Fish", value: "Gold Fish" },
    { type: "Fish", label: "Koi Fish", value: "Koi Fish" },
    { type: "Fish", label: "Oscar Fish", value: "Oscar Fish" },
    { type: "Fish", label: "Catfishes", value: "Catfishes" },
    { type: "Fish", label: "Grass Carp Fish", value: "Grass Carp Fish" },
  ];
export const hasValue=(value)=> {
  if (value === null || value === undefined) {
    return false;
  }
  
  // Handle strings (including whitespace-only strings)
  if (typeof value === 'string') {
    return value.trim().length > 0;
  }
  
  // Handle numbers (including 0)
  if (typeof value === 'number') {
    return !isNaN(value) && value !== 0;
  }
  
  // Handle arrays and objects
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  
  if (typeof value === 'object') {
    return Object.keys(value).length > 0;
  }
  
  // For booleans, functions, etc. - they have value
  return true;
}
export const numberToWords=(amount)=> {
  const ones = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
    "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];
  
  const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
  ];

  const scales = ["", "Thousand", "Million", "Billion", "Trillion"];

  if (isNaN(amount)) return "Not a number";
  if (amount === 0) return "Zero";

  function convertHundreds(num) {
    let str = "";
    if (num > 99) {
      str += ones[Math.floor(num / 100)] + " Hundred ";
      num %= 100;
    }
    if (num > 19) {
      str += tens[Math.floor(num / 10)] + " ";
      num %= 10;
    }
    if (num > 0) {
      str += ones[num] + " ";
    }
    return str.trim();
  }

  let word = "";
  let scaleIndex = 0;

  while (amount > 0) {
    let chunk = amount % 1000;
    if (chunk) {
      word = convertHundreds(chunk) + " " + scales[scaleIndex] + " " + word;
    }
    amount = Math.floor(amount / 1000);
    scaleIndex++;
  }

  return word.trim();
}

  export const saveFcmTokenData=async(store,user)=>{
  
      const token = await generateFcmToken();
     console.log("savefromtokendata",token);

  if (!token) return;
     try{
   const response=await saveFcmToken(token,user?.key,store?.key,user?.RegistrationID,"");
     }
     catch(error){
      console.log("error",error);
     }

  }


  
  export const saveLoginRecordData=async(store,user)=>{
  
     
     try{
     const data = {
                    UserID: user?.UID,
                    RegistrationID: user?.RegistrationID,
                    StoreName:store.StoreName,
                    StoreID: store.key,
                    LoginSource: "Web.Posible"
                  }
                  await saveLoginRecord(data);
     }
     catch(error){
      console.log("error",error);
     }

  }



  

    export const deleteFcmTokenData=async()=>{
  
      const token = await generateFcmToken();
     console.log("savefromtokendata",token);

  if (!token) return;
     try{
   const response=await deleteFcmToken(token);
     }
     catch(error){
      console.log("error",error);
     }

  }

  
export const formatDateTime = (timestamp,includeTime=false,type = 'default',timezone = 'local') => {

// console.log("teimstamp",timestamp);
  if (!timestamp) return "";

  // If value looks like seconds (10 digits), convert to ms
  const normalizedTimestamp = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp;
  
  const date = new Date(normalizedTimestamp);

  if (isNaN(date.getTime())) return "Invalid date";

  // Helper functions to get date components based on timezone
  const getYear = () => timezone === 'utc' ? date.getUTCFullYear() : date.getFullYear();
  const getMonth = () => timezone === 'utc' ? date.getUTCMonth() : date.getMonth();
  const getDate = () => timezone === 'utc' ? date.getUTCDate() : date.getDate();
  const getHours = () => timezone === 'utc' ? date.getUTCHours() : date.getHours();
  const getMinutes = () => timezone === 'utc' ? date.getUTCMinutes() : date.getMinutes();
  const getSeconds = () => timezone === 'utc' ? date.getUTCSeconds() : date.getSeconds();
  const getDay = () => timezone === 'utc' ? date.getUTCDay() : date.getDay();

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                     "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  
  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  if (type === 'withMonth') {
    // Format: Thu Sep 25 2025
    const dayName = dayNames[getDay()];
    const monthName = monthNames[getMonth()];
    const day = getDate();
    const year = getYear();
    
    let result = `${dayName} ${monthName} ${day} ${year}`;
    
    if (includeTime) {
      const hours = String(getHours()).padStart(2, "0");
      const minutes = String(getMinutes()).padStart(2, "0");
      const seconds = String(getSeconds()).padStart(2, "0");
      result += ` ${hours}:${minutes}:${seconds}`;
    }
    
    return result;
  } else {
    // Default format: yyyy-mm-dd
    const year = getYear();
    const month = String(getMonth() + 1).padStart(2, "0");
    const day = String(getDate()).padStart(2, "0");
    
    let result = `${year}-${month}-${day}`;
    console.log("includeTime",includeTime);
    if (includeTime) {
      const hours = String(getHours()).padStart(2, "0");
      const minutes = String(getMinutes()).padStart(2, "0");
      const seconds = String(getSeconds()).padStart(2, "0");
      result += ` ${hours}:${minutes}:${seconds}`;
    }
    
    return result;
  }
};


export const getMonth = (month) => {
  const monthMap = {
    jan: "01",
    feb: "02",
    mar: "03",
    apr: "04",
    may: "05",
    jun: "06",
    jul: "07",
    aug: "08",
    sep: "09",
    oct: "10",
    nov: "11",
    dec: "12"
  };
  
  return monthMap[month.toLowerCase()] || "";
};

export const checkDateFormat = (data, format, type) => {
  if (!data || !format) return null;
  
  const formatLower = format.toLowerCase();
  const normalizedData = data.trim();
  
  // Common validation patterns
  const patterns = {
    'mm/yy': /^\d{2}[\/\-]\d{2}$/,
    'mm-yy': /^\d{2}[\/\-]\d{2}$/,
    'mmm/yy': /^[a-z]{3}[\/\-]\d{2}$/i,
    'mmm-yy': /^[a-z]{3}[\/\-]\d{2}$/i,
    'mmm/yyyy': /^[a-z]{3}[\/\-]\d{4}$/i,
    'mmm-yyyy': /^[a-z]{3}[\/\-]\d{4}$/i,
    'dd/mm/yy': /^\d{1,2}[\/\-]\d{1,2}[\/\-]\d{2}$/,
    'dd-mm-yy': /^\d{1,2}[\/\-]\d{1,2}[\/\-]\d{2}$/,
    'dd/mmm/yyyy': /^\d{1,2}\/[a-z]{3}\/\d{4}$/i,
    'dd-mmm-yyyy': /^\d{1,2}\-[a-z]{3}\-\d{4}$/i
  };

  // Check if format is supported
  if (!patterns[formatLower]) return null;
  
  // Validate pattern
  if (!patterns[formatLower].test(normalizedData)) return null;

  try {
    let dd, mm, yy, yearPrefix;
    const separator = formatLower.includes('/') ? '/' : '-';
    const parts = normalizedData.split(separator);

    switch (formatLower) {
      case 'mm/yy':
      case 'mm-yy':
        mm = parts[0];
        yy = parts[1];
        if (Number(mm) < 1 || Number(mm) > 12) return null;
        yearPrefix = yy.length === 2 ? '20' : '';
        return new Date(
          `${yearPrefix}${yy}`,
          type === 'exp' ? Number(mm) - 1 : Number(mm) - 1,
          type === 'exp' ? 0 : 1
        );

      case 'mmm/yy':
      case 'mmm-yy':
        mm = getMonth(parts[0]);
        yy = parts[1];
        if (!mm) return null;
        return new Date(
          `20${yy}`,
          type === 'exp' ? Number(mm) - 1 : Number(mm) - 1,
          type === 'exp' ? 0 : 1
        );

      case 'mmm/yyyy':
      case 'mmm-yyyy':
        mm = getMonth(parts[0]);
        yy = parts[1];
        if (!mm) return null;
        return new Date(
          yy,
          type === 'exp' ? Number(mm) - 1 : Number(mm) - 1,
          type === 'exp' ? 0 : 1
        );

      case 'dd/mm/yy':
      case 'dd-mm-yy':
        dd = parts[0];
        mm = parts[1];
        yy = parts[2];
        if (Number(mm) < 1 || Number(mm) > 12) return null;
        if (Number(dd) < 1 || Number(dd) > 31) return null;
        return new Date(`20${yy}`, Number(mm) - 1, Number(dd));

      case 'dd/mmm/yyyy':
      case 'dd-mmm-yyyy':
        dd = parts[0];
        mm = getMonth(parts[1]);
        yy = parts[2];
        if (!mm || Number(dd) < 1 || Number(dd) > 31) return null;
        return new Date(yy, Number(mm) - 1, Number(dd));

      default:
        return null;
    }
  } catch (error) {
    return null;
  }
};

export const usePhoneNoValidation=()=>{
const registration=useSelector(selectRegistration);

 const getPhoneNumberDigit = () => {
    return registration?.PhoneNoDigit || 10;
  };

  const getDialCode = () => {
    return registration?.DialCode || +91;
  }
 return { getPhoneNumberDigit, getDialCode };
}

export const isMobileView = () => window.innerWidth < 768;

export const useAcl = () => {
  const acl = useSelector((state) => state.acl.acl);
  
  const getVisibility = (module, access) => {
    if (!acl) return false;
    
    const moduleAcl = acl.find((e) => e.id === module);
    if (!moduleAcl) return false;
    
    switch (access) {
      case "create":
        return moduleAcl.perms.create;
      case "read":
        return moduleAcl.perms.read;
      case "update":
        return moduleAcl.perms.update;
      case "delete":
        return moduleAcl.perms.delete;
      case "export":
        return moduleAcl.perms.export;
      default:
        return false;
    }
  };
  
  return { getVisibility };
}; 

export const formatDate = (value) => {
  if (!value) return "";

  console.log("formatDate received:", value, "Type:", typeof value);

  let date;

  // ✅ Firebase Timestamp (with underscore)
  if (typeof value === "object" && value._seconds !== undefined) {
    date = new Date(value._seconds * 1000);
  }
  // ✅ Firebase Timestamp (without underscore)
  else if (typeof value === "object" && value.seconds !== undefined) {
    date = new Date(value.seconds * 1000);
  }
  // ✅ Firebase Timestamp with toDate()
  else if (typeof value === "object" && typeof value.toDate === "function") {
    date = value.toDate();
  }
  // ✅ String date (ISO format)
  else if (typeof value === "string") {
    date = new Date(value);
    if (isNaN(date.getTime())) return ""; // Invalid date string
  }
  // ✅ MongoDB / JS Date object
  else if (value instanceof Date) {
    date = value;
  }
  // ✅ Number or numeric string (seconds or milliseconds)
  else {
    const timestamp = Number(value);
    if (isNaN(timestamp)) return "";

    date =
      timestamp.toString().length === 10
        ? new Date(timestamp * 1000) // seconds
        : new Date(timestamp);       // milliseconds
  }

  // Format as YYYY-MM-DD
  return date.toISOString().split("T")[0];
};
